const _ = require('lodash');

const schema = require('./schema');

/**
 * Formatters are functions that take a response and transforms it into a more friendly common use
 * @namespace formatters
 */

/**
 * Named mapper to a formatter function
 * @type {{String: function}}
 * @memberof formatters
 */
const formatters = {
  'schema-name-argument': schema.nameArgument,
};

/**
 * Runs the formatting process
 * @param {formatters|String} name the name of the formatter
 * @param {Object|Array|*} args the incoming arguments
 * @returns {*} the formatted value/s
 * @memberof formatters
 */
module.exports = (name, args) => {
  // check it exists
  if (!_.has(formatters, name)) {
    throw new Error(`invalid-formatter:${name}`);
  }
  // do the formatting
  return formatters[name](args);
};
